import { styled } from "styled-components";

import { FolderIcon, Image } from "common/components";
import { breakpoints } from "common/styles";

const StyledContainer = styled.div`
  position: relative;
  height: 8rem;

  @media ${breakpoints.extraLarge} {
    height: auto;
  }
`;

const StyledMapTopicIcon = styled(FolderIcon)`
  color: ${({ theme }) => theme.colors.blue};
  opacity: 0.94;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: scale(0.6);

  @media ${breakpoints.extraLarge} {
    transform: scale(0.7);
  }
`;

const StyledTextCenteringContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
`;

const StyledTitle = styled.p`
  margin: auto;
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: white;
  width: 8rem;
`;

const StyledImageCircle = styled(Image)`
  border-radius: 50%;
  height: 7.5rem;
  width: 7.5rem;
  filter: brightness(80%);
  border: 3px solid ${({ theme }) => theme.colors.blue};

  @media ${breakpoints.extraLarge} {
    height: 10rem;
    width: 10rem;
  }
`;

type MapTopicProps = { imageUrl: string | undefined; title: string };

export const MapTopic = ({ title, imageUrl }: MapTopicProps) => (
  <StyledContainer>
    <StyledImageCircle src={imageUrl} alt={title} />
    <StyledMapTopicIcon />
    <StyledTextCenteringContainer>
      <StyledTitle>{title}</StyledTitle>
    </StyledTextCenteringContainer>
  </StyledContainer>
);
